export default __webpack_public_path__ + "static/media/dashboard_before.528124ae.jpg";